export default __webpack_public_path__ + "static/media/BhartiAXA.e7970b86.svg";